import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, map } from 'rxjs';
import { AccountService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AccountExistsGuard {
  router = inject(Router);
  private accountService = inject(AccountService);

  accountExists(): Observable<boolean> {
    return this.accountService.actionExist().pipe(
      map((resp: any) => {
        return resp.success ? true : false;
      })
    );
  }

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.accountExists().pipe(
      tap((x: any) => {
        if (!x) {
          this.router.navigate(['account/register']);
        }
      })
    );
  }
}
